import styled from 'styled-components'

export const TermsAndConditionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: scroll;

  scrollbar-width: none;
  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  article {
    flex: 1;

    box-sizing: border-box;
    border: 1px solid rgba(15, 87, 13, 0.1);
    border-radius: 5px;
    background: rgba(182, 215, 180, 0.1);
    width: 914px;

    padding: 0;
    margin-bottom: ${({ theme }) => theme.spacings[3]};
    height: 100%;

    overflow-y: auto;

    /* h2 {
      text-align: center;
      color: ${({ theme }) => theme.colors.greyishBrownFive};
    }

    p {
      color: ${({ theme }) => theme.colors.pinkishGrey};
      margin-bottom: ${({ theme }) => theme.spacings[4]};
    } */
  }

  button {
    margin: 0 auto;
  }

  button + button {
    margin-top: ${({ theme }) => theme.spacings[2]};
  }

  .container-buttons {
    button {
      margin-top: 40px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 392px;
      background: ${({ theme }) => theme.colors.primary};
    }

    button + button {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 392px;
      margin-top: ${({ theme }) => theme.spacings[2]};
      background: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`

export const AcceptTermsCheck = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-top: ${({ theme }) => theme.spacings[3]};

  label {
    order: 2;
    margin-left: ${({ theme }) => theme.spacings[2]};
    /* color: ${({ theme }) => theme.colors.pinkishGrey}; */
  }
`
